import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, FlexboxGrid, Message } from 'rsuite'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import InputForm from '../../../components/forms/input/InputForm'
import InputCascaderForm from '../../../components/forms/input/InputCascaderForm'
import { locationZipcode } from '../../../components/location/Location'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import InputRadioForm from '../../../components/forms/input/InputRadioForm'
import InputDateForm from '../../../components/forms/input/InputDateForm'
import UploaderForm from '../../../components/forms/input/UploaderForm'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import InputCheckboxForm from '../../../components/forms/input/InputCheckboxForm'
import SubProjectAddressInput from '../../subProject/address/SubProjectAddressInput'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import { doneLoading, startLoading } from '../../../utils/loading'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { downloadSubprojectFile } from '../../../redux/actions/subProject'
import notification from '../../../utils/notification'
import { cloneDeep, isEmpty } from 'lodash-es'
import CustomAlertMessage from '../../CustomAlertMessage'
import HTMLWidget from '../../HTMLWidget'

export default function EditFormWidget({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  disabled,
  objectDatas,
  ignoreDesc,
  setLoading = () => {},
  style = { marginBottom: -20 },
  conditions,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [location, setLocation] = useState([])
  const [objects, setObjects] = useState([])

  const [dataMap, setDataMap] = useState(new Map())

  useEffect(() => {
    if (!objectDatas) {
      setObjectsData(_schema?.objects)
    }

    setSchema(_schema)
  }, [_schema])

  useEffect(() => {
    if (objectDatas) {
      setObjectsData(objectDatas)
    }
  }, [objectDatas])

  const setObjectsData = (objects) => {
    var location = objects?.find((e) => e.type == 'lOCATION_CASCADER')
    if (location) {
      handleLocation()
    }

    let datas = getObjectData(objects)

    let dataM = new Map()

    objects?.forEach((e) => {
      dataM.set(e.name, e.value)
    })

    setDataMap(dataM)
    setObjects(datas)
  }

  const getObjectData = (objDatas) => {
    let result = []
    if (objDatas) {
      let uniqueViewGoups = objDatas.reduce((acc, obj) => {
        if (!acc.includes(obj['viewGoup'])) {
          acc.push(obj['viewGoup'])
        }
        return acc
      }, [])

      let datas = []

      uniqueViewGoups?.forEach((e) => {
        datas.push(objDatas.filter((item) => item.viewGoup == e))
      })

      result = datas
    }

    return result
  }

  const handleLocation = async () => {
    setLoading(true)
    let locationJson = await locationZipcode()
    setLocation(locationJson || [])
    setLoading(false)
  }

  const onDownload = async (path, name) => {
    startLoading()
    try {
      var file = await downloadSubprojectFile(path)

      downloadFile(file, name)
    } catch (e) {
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
  }

  const onPreview = async (path, name) => {
    startLoading()
    try {
      var file = await downloadSubprojectFile(path)

      previewFile(file, name)
    } catch (e) {
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
  }

  const setAlertMessage = (type, message) => {
    notification.open(type, {
      title: message,
      duration: 2500,
    })
  }

  const onChange = (name, data) => {
    let dataM = cloneDeep(dataMap)
    dataM.set(name, data)
    setDataMap(dataM)
  }

  const renderInput = (inputForms) => {
    let result = inputForms?.map((e) => {
      return (
        <FlexboxGrid>
          {e.map((item) => {
            if (item.type == 'ADDRESS') {
              //let datas = getObjectData(item.subSchema?.objects)

              return (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={24} lg={24}>
                  <div
                  // style={{ marginLeft: -20, marginRight: -20 }}
                  >
                    {item.subSchemas?.map((e) => {
                      return (
                        <SubProjectAddressInput
                          bordered
                          schema={e}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          setLoading={setLoading}
                        />
                      )
                    })}
                  </div>
                </FlexboxGrid.Item>
              )
            } else {
              let inputObj

              let con = conditions?.find((e) => e.name == item.name)
              let conDisabled = false
              if (con) {
                conDisabled = dataMap.get(con.ref) != con.value
              }

              switch (item.type) {
                case 'INPUT':
                  inputObj = (
                    <InputForm
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      showLimitLength={item.showLimitLength}
                      disabled={disabled || schema.disabled || conDisabled}
                    />
                  )
                  break
                case 'INPUT_NUMBER':
                  inputObj = (
                    <InputForm
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      isInputNumber
                      disabled={disabled || schema.disabled}
                    />
                  )
                  break
                case 'INPUT_AREA':
                  inputObj = (
                    <InputForm
                      schema={item}
                      rows={4}
                      componentClass="textarea"
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={schema.disabled}
                    />
                  )
                  break
                case 'EDITOR':
                  inputObj = (
                    <CKEditorFrom
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={disabled || schema.disabled}
                    />
                  )
                  break
                case 'DOPDOWN':
                  inputObj = (
                    <InputSelectForm
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={disabled || schema.disabled}
                      onChange={(value) => {
                        onChange(item.name, value)
                      }}
                    />
                  )
                  break
                case 'RADIO':
                  inputObj = (
                    <InputRadioForm
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={disabled || schema.disabled}
                      onChange={(value) => {
                        onChange(item.name, value)
                      }}
                    />
                  )
                  break
                case 'CHECKBOX':
                  inputObj = (
                    <InputCheckboxForm
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={disabled || schema.disabled}
                      onChange={(value) => {
                        onChange(item.name, value)
                      }}
                    />
                  )
                  break
                case 'CASCADER':
                  inputObj = (
                    <InputCascaderForm
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={disabled || schema.disabled}
                    />
                  )
                  break
                case 'lOCATION_CASCADER':
                  inputObj = (
                    <InputCascaderForm
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      cascaderDatas={location}
                      disabled={disabled || schema.disabled}
                    />
                  )
                  break
                case 'DATE':
                  inputObj = (
                    <InputDateForm
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={disabled || schema.disabled}
                    />
                  )
                  break
                case 'UPLOAD':
                  inputObj = (
                    <UploaderForm
                      schema={item}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      disabled={disabled || schema.disabled}
                      onChange={(value) => {
                        onChange(item.name, value)
                      }}
                    />
                  )
                  break
                case 'SINGLE_UPLOAD':
                  inputObj = (
                    <>
                      <UploaderForm
                        schema={item}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        single={true}
                        ignoreValidate={!isEmpty(item.value)}
                        disabled={disabled || schema.disabled}
                      />
                      {item.value && (
                        <div style={{ marginTop: 10 }}>
                          <ViewButton
                            style={{
                              marginRight: 10,
                              marginLeft: 10,
                              marginBottom: 10,
                            }}
                            // disabled={!subItem.value}
                            onClick={() => {
                              var fileNames = item.value.split('/')
                              onPreview(item.value, fileNames?.pop() || 'preview')
                            }}
                          />
                          <DownloadButton
                            //disabled={!subItem.value}
                            onClick={() => {
                              var fileNames = item.value.split('/')
                              onDownload(item.value, fileNames?.pop() || 'download')
                            }}
                          />
                        </div>
                      )}
                    </>
                  )
                  break
                case 'MSG':
                  inputObj = (
                    <Message
                      style={{ marginTop: 10 }}
                      showIcon
                      type={item.value || 'success'}
                      description={item.valueDef}
                    />
                  )
                  break
                case 'DATA':
                  inputObj = (
                    <div style={{ marginTop: 20, marginBottom: 10 }}>
                      <HTMLWidget data={item.value} />
                    </div>
                  )
                  break
                case 'LABEL':
                  inputObj = (
                    <div style={{ marginTop: 10 }}>
                      <strong>{item.label}</strong>
                    </div>
                  )
                  break
                case 'HEADER_LABEL':
                  inputObj = (
                    <div style={{ marginTop: 20, marginBottom: 10 }}>
                      <strong>{item.label}</strong>
                    </div>
                  )
                  break
                default:
                  break
              }

              return (
                <FlexboxGrid.Item
                  componentClass={Col}
                  colspan={24}
                  xs={24}
                  sm={24}
                  md={item.sizeMdLg || 24}
                  lg={item.sizeMdLg || 24}
                >
                  {inputObj}
                </FlexboxGrid.Item>
              )
            }
          })}
        </FlexboxGrid>
      )
    })

    return result
  }

  return (
    <Panel style={style}>
      <Row>
        {!ignoreDesc && schema.description && schema.description.length > 0 && (
          <Col style={{ marginBottom: 15 }}>
            <CustomAlertMessage contents={schema.description} />
          </Col>
        )}

        {renderInput(objects)}
      </Row>
    </Panel>
  )
}
